export default __webpack_public_path__ + "static/media/star_active.6e5794be.svg";